import Box, { BoxProps } from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import { GreyPallet } from "../../config/styles";

interface ExpandMoreProps extends BoxProps {
  noPadding?: boolean;
  noMargin?: boolean;
}

const MainBox = styled((props: ExpandMoreProps) => {
  const { noPadding, noMargin, ...other } = props;
  return <Box {...other} />;
})(({ theme, noPadding, noMargin }) => ({
  backgroundColor: GreyPallet.Light,
  borderRadius: "15px",

  marginBottom: noMargin ? "0px" : theme.spacing(2),

  paddingLeft: noPadding ? "0px" : theme.spacing(2),
  paddingRight: noPadding ? "0px" : theme.spacing(2),
  paddingTop: noPadding ? "0px" : theme.spacing(1),
  paddingBottom: noPadding ? "0px" : theme.spacing(1),
}));

export default MainBox;
